export const toggleRejectMenu = (toggle: boolean): any => ({ type: actions.TOGGLE, toggle });

const actions: any = { TOGGLE: 'rejectMenu/TOGGLE' };
export default actions;
